import {React, useEffect} from 'react';
import Navbar from './components/Navbar';
import HomeSection from './components/Home';
import About from './components/About';
import Services from './components/Services';
import ContactUs from './components/Contact';
import './App.css'; // Import CSS for styling
import './components/base.css';
// import './components/main.css';
// import './components/vendor.css';
import 'font-awesome/css/font-awesome.min.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';  // Importing React Router components
import BlogPage from './components/BlogPage';
import ArticlePage from './components/ArticlePage';

function App() {

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-out',
      once: false,
      offset: 100,
      delay: 0,
      mirror: true, // Whether elements should animate out while scrolling past them
      anchorPlacement: 'top-bottom', // Defines which position of the element regarding to window should trigger the animation
      disable: 'mobile' // Disables animations on mobile devices with width less than 768px
    });
  }, []);

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 1000, // Animation duration
      once: true,     // Whether animation should happen only once
      easing: 'ease-in-out',
      offset: 120     // Offset (in px) from the original trigger point
    });
  }, []);

  // return (
  //   <div className="App">
  //     <Header />
  //     <Home />
  //     <Services />
  //     <About />
  //     <ContactUs/>
  //   </div>
  // );

  return (
    <Router>  {/* Wrapping the app in Router for routing functionality */}
        <Routes>
          {/* Defining routes for each page */}
              <Route path="/" element={
                <div className="App">
                      {/* <Header /> */}
                      <Navbar />
                      <HomeSection />
                      <Services />
                      <About />
                      <ContactUs/>
                  </div>} />
            <Route path="/blog" element={<BlogPage/>}></Route>
            <Route path="/article/:id" element={<ArticlePage />} />  {/* Route for individual article */}
          </Routes>
    </Router>
  );
}

export default App;